/* ==========================================================================
   IGS 6周年記念LP — lp-anniv-6th.js
   実装指示書: 5. アンカーナビ / 7. 実装順序 優先度1

   実装範囲
     「トップへ戻る」ボタンの表示制御とスクロール。
     演出3種（フェードアップ / 数値のカウントアップ / 主CTAの誘目パルス）。
     ※ パルスはCSSのみ。JSは他2つを担当する。

   設計方針
     - アンカーナビは追従させない（固定バー36px＋ナビ40pxで76pxを常時
       占有し、モバイル縦幅の約12%を食うため）。代わりにこのボタンで
       ページ最上部＝ナビへ戻れるようにする。
     - スクロール量が閾値（既定500px）を超えたら表示、下回ったら非表示。
     - 表示制御は class の付け外しのみ。非表示時は visibility: hidden に
       なるためタブ順からも外れる（CSS側で定義）。
     - localStorage / sessionStorage は一切使用しない。
     - prefers-reduced-motion: reduce のときはスムーススクロールを行わず
       即座に最上部へ移動する。設定変更にも追従する。
     - スクロールイベントは passive + requestAnimationFrame で間引く。
       ガチャ演出と同居しても低スペック端末で詰まらないようにするため。
     - このファイルは defer で読み込まれる前提（DOM構築後に実行される）。
       同じ src が複数回出力されても二重初期化しないようガードしている。
   ========================================================================== */

(function () {
  'use strict';

  if (window.__anniv6thBackToTop) return;
  window.__anniv6thBackToTop = true;

  var VISIBLE_CLASS = 'is-visible';
  var DEFAULT_THRESHOLD = 500;

  function init() {
    var button = document.querySelector('[data-anniv-back-to-top]');
    if (!button) return;

    var threshold = parseInt(button.getAttribute('data-threshold'), 10);
    if (isNaN(threshold) || threshold < 0) threshold = DEFAULT_THRESHOLD;

    // 動きを減らす設定。ユーザーが設定を変えたら即座に追従する
    var motionQuery = window.matchMedia
      ? window.matchMedia('(prefers-reduced-motion: reduce)')
      : null;

    function prefersReducedMotion() {
      return !!(motionQuery && motionQuery.matches);
    }

    var visible = null; // 初回は必ず反映させるため null 始まり
    var ticking = false;

    function apply() {
      ticking = false;

      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      var shouldShow = y > threshold;

      if (shouldShow === visible) return;
      visible = shouldShow;

      button.classList.toggle(VISIBLE_CLASS, shouldShow);
      // 非表示のあいだは支援技術からも隠す（CSSのvisibilityと二重で担保）
      button.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(apply);
    }

    button.addEventListener('click', function (event) {
      event.preventDefault();

      if (prefersReducedMotion()) {
        window.scrollTo(0, 0);
      } else {
        try {
          window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        } catch (e) {
          // scrollTo のオプション形式に未対応の環境向け
          window.scrollTo(0, 0);
        }
      }

      // スクロール後のフォーカスをページ先頭へ戻す。
      // キーボード操作で押したとき、フォーカスが画面外に取り残されないようにする。
      var first = document.querySelector('.anniv-6th');
      if (first && typeof first.focus === 'function') {
        if (!first.hasAttribute('tabindex')) first.setAttribute('tabindex', '-1');
        first.focus({ preventScroll: true });
      }
    });

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });

    apply();
  }

  /* ========================================================================
     演出1: フェードアップ（.anniv-reveal）

     なぜ初期状態を「見える」ままにするか
       JSが読み込まれない環境、IntersectionObserver 非対応の環境で
       opacity: 0 のまま取り残されると、本文が永久に見えなくなる。
       CSSは .anniv-6th.is-motion-ready の配下でのみ要素を隠す。
       このクラスはJSが付けるので、JSが動かない＝最初から見えている。

     動きを減らす設定のときは is-motion-ready を付けない（＝隠さない）。
     ======================================================================== */

  function initReveal(reduced) {
    var targets = document.querySelectorAll('.anniv-reveal');
    if (!targets.length) return;

    // 非対応環境・動きを減らす設定では、そのまま見せて終わり
    if (reduced || !('IntersectionObserver' in window)) return;

    var roots = document.querySelectorAll('.anniv-6th');
    for (var i = 0; i < roots.length; i++) {
      roots[i].classList.add('is-motion-ready');
    }

    var observer = new IntersectionObserver(function (entries) {
      for (var j = 0; j < entries.length; j++) {
        if (!entries[j].isIntersecting) continue;
        entries[j].target.classList.add('is-in');
        observer.unobserve(entries[j].target);
      }
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.01 });

    for (var k = 0; k < targets.length; k++) {
      observer.observe(targets[k]);
    }
  }

  /* ========================================================================
     演出2: 数値のカウントアップ（[data-anniv-countup]）

     文字列の「最初の数値」だけを数える。単位や記号はそのまま残す。
       '2,200円分' → 2200 まで数えて '2,200円分' に戻る
       '20%'       → 20 まで数えて '20%' に戻る
     小数は扱わない（LPに出てくる数値が全て整数のため）。

     桁の揺れは font-variant-numeric: tabular-nums（CSS側）で止めている。
     途中経過も元の桁区切りを保つので、レイアウトが動かない。
     ======================================================================== */

  var NUM_PATTERN = /\d[\d,]*/;
  var COUNT_MS = 900;

  function hasSeparator(text) {
    return text.indexOf(',') !== -1;
  }

  function formatNumber(value, separated) {
    var s = String(value);
    if (!separated) return s;
    return s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function runCountUp(el) {
    var original = el.textContent;
    var match = original.match(NUM_PATTERN);
    if (!match) return;

    var raw = match[0];
    var target = parseInt(raw.replace(/,/g, ''), 10);
    if (isNaN(target) || target <= 0) return;

    var separated = hasSeparator(raw);
    var prefix = original.slice(0, match.index);
    var suffix = original.slice(match.index + raw.length);
    var start = null;

    function step(now) {
      if (start === null) start = now;
      var progress = (now - start) / COUNT_MS;
      if (progress > 1) progress = 1;

      // ease-out。最後だけゆっくり止まる
      var eased = 1 - Math.pow(1 - progress, 3);
      var value = Math.round(target * eased);

      el.textContent = prefix + formatNumber(value, separated) + suffix;

      if (progress < 1) {
        window.requestAnimationFrame(step);
      } else {
        // 端数誤差を残さないため、最後は元の文字列そのものに戻す
        el.textContent = original;
      }
    }

    window.requestAnimationFrame(step);
  }

  function initCountUp(reduced) {
    var targets = document.querySelectorAll('[data-anniv-countup]');
    if (!targets.length) return;

    // 動きを減らす設定・非対応環境では、確定値がそのまま出ている状態で終わり
    if (reduced || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (!entries[i].isIntersecting) continue;
        var el = entries[i].target;
        observer.unobserve(el);   // 1要素につき1回だけ
        runCountUp(el);
      }
    }, { threshold: 0.6 });

    for (var j = 0; j < targets.length; j++) {
      observer.observe(targets[j]);
    }
  }

  function initMotion() {
    var motionQuery = window.matchMedia
      ? window.matchMedia('(prefers-reduced-motion: reduce)')
      : null;
    var reduced = !!(motionQuery && motionQuery.matches);

    initReveal(reduced);
    initCountUp(reduced);
  }

  // defer 前提だが、他所から読み込まれた場合の保険
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
      initMotion();
    });
  } else {
    init();
    initMotion();
  }
})();
